<div class="reset-password-container">

  @if (invalidLink) {
    <div class="alert alert-danger">
      <h2>{{ 'auth.invalidLink' | t }}</h2>
      <p>{{ 'auth.resetInvalidLink' | t }}</p>
    </div>
  }

  @if (!invalidLink) {
    @if (!success) {
      <div>
        <h2>{{ 'auth.resetTitle' | t }}</h2>
        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="password">{{ 'auth.newPassword' | t }}</label>
            <input type="password" id="password" formControlName="password" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
            @if (f.password.value) {
              <div class="password-strength">
                <div class="strength-bar-track">
                  <div class="strength-bar-fill" [ngClass]="strengthLevel"></div>
                </div>
                <span class="strength-label" [ngClass]="strengthLevel">
                  {{ 'password.strength' | t }}
                  <strong>{{ ('password.' + strengthLevel) | t }}</strong>
                </span>
              </div>
            }
            <ul class="password-rules">
              <li [class.valid]="!f.password.errors?.minlength">{{ 'password.ruleLength' | t }}</li>
              <li [class.valid]="!f.password.errors?.lowercase">{{ 'password.ruleLowercase' | t }}</li>
              <li [class.valid]="!f.password.errors?.uppercase">{{ 'password.ruleUppercase' | t }}</li>
              <li [class.valid]="!f.password.errors?.digit">{{ 'password.ruleDigit' | t }}</li>
              <li [class.valid]="!f.password.errors?.specialChar">{{ 'password.ruleSpecial' | t }}</li>
            </ul>
          </div>
          <div class="form-group">
            <label for="confirmPassword">{{ 'auth.confirmNewPassword' | t }}</label>
            <input type="password" id="confirmPassword" formControlName="confirmPassword" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && resetForm.errors?.passwordsMismatch }" />
            @if (submitted && resetForm.errors?.passwordsMismatch) {
              <div class="invalid-feedback">
                {{ 'common.passwordsMismatch' | t }}
              </div>
            }
          </div>
          <button [disabled]="loading" class="btn btn-primary">
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{ 'auth.resetButton' | t }}
          </button>
          @if (error) {
            <div class="alert alert-danger mt-3 mb-0">{{error}}</div>
          }
        </form>
      </div>
    }
    @if (success) {
      <div class="alert alert-success">
        <h2>{{ 'auth.resetSuccessTitle' | t }}</h2>
        <p>{{ 'auth.resetSuccessText' | t }}</p>
        <button class="btn btn-primary" (click)="openLogin()">{{ 'auth.loginButton' | t }}</button>
      </div>
    }
  }
</div>
